import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["target", "href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["io-btn-wrapper", _ctx.wrapperClasses])
  }, [
    _createElementVNode("a", {
      target: _ctx.target,
      href: _ctx.href,
      class: _normalizeClass(["io-btn", _ctx.btnClasses])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 10, _hoisted_1)
  ], 2))
}